// extracted by mini-css-extract-plugin
export default {"wrapper":"PointReductionToolbar_wrapper__ovwpb","select":"PointReductionToolbar_select__GsdU+","btn":"PointReductionToolbar_btn__1Vc3c","icon":"PointReductionToolbar_icon__1evca"};